<template>
    <b-sidebar id="sidebar" aria-labelledby="Menu" no-header shadow width="60%">
        <b-row class="p-2 mb-3">
            <b-col id="logo-container" class="d-flex">
                <b-link href="https://www.assistel.paris/">
                    <img :src="logo.source" :alt="logo.alt" />
                </b-link>
            </b-col>
        </b-row>

        <b-nav pills vertical class="nav-pills-vertical">
            <b-nav-item to="/">Création & Domiciliation</b-nav-item>
            <b-nav-item href="https://www.assistel.paris/permanence-telephone-medical-paris">Permanence téléphonique médicale</b-nav-item>
            <b-nav-item href="https://www.assistel.paris/secretariat-externalise-paris">Standard externalisé</b-nav-item>
            <b-nav-item href="https://www.assistel.paris/contact">Contact</b-nav-item>
            <b-nav-item href="https://www.assistel.paris/blog">Blog</b-nav-item>
        </b-nav>
    </b-sidebar>
</template>

<script>
    export default {
        data() {
            return {
                logo: {
                    source: require("@/assets/images/assistel.png"),
                    alt: "Logo de Assistel"
                }
            }
        }
    }
</script>

<style lang="css">
    .nav-link
    {
        border-radius: 0 !important;
    }
</style>
